export const categories = [
  {
    id: 'football',
    name: '足球',
    icon: 'ri-football-line',
    slug: 'football',
    description: '全球顶级足球赛事直播与专业分析，涵盖英超、西甲、欧冠等热门联赛',
  },
  {
    id: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    slug: 'basketball',
    description: 'NBA、CBA及国际篮联赛事全覆盖，实时比分与深度战报',
  },
  {
    id: 'tennis',
    name: '网球',
    icon: 'ri-base-station-line',
    slug: 'tennis',
    description: '四大满贯及ATP/WTA巡回赛，专业数据分析与赛事预测',
  },
  {
    id: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    slug: 'esports',
    description: 'LOL、DOTA2、CS2等顶级电竞赛事，实时直播与专业解说',
  },
  {
    id: 'racing',
    name: '赛车',
    icon: 'ri-steering-2-line',
    slug: 'racing',
    description: 'F1、MotoGP等全球顶级赛车赛事，速度与激情的极致体验',
  },
  {
    id: 'combat',
    name: '格斗',
    icon: 'ri-boxing-line',
    slug: 'combat',
    description: 'UFC、拳击等格斗赛事，最火爆的对抗竞技体验',
  },
];

export const featuredArticles = [
  {
    id: 'article-1',
    title: '2026赛季英超联赛前瞻：群雄逐鹿，谁主沉浮',
    excerpt: '新赛季英超即将拉开帷幕，各支豪门球队经过夏窗调整后实力如何？本文为您深度解析新赛季英超格局。',
    category: '足球',
    categorySlug: 'football',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20at%20sunset%20with%20dramatic%20lighting%2C%20green%20pitch%20with%20stadium%20lights%20glowing%2C%20atmospheric%20sports%20photography%2C%20cinematic%20composition%2C%20warm%20golden%20tones%2C%20crowd%20silhouettes%20in%20background&width=800&height=500&seq=article-football-1&orientation=landscape',
    date: '2026-08-05',
    readTime: '8分钟',
    featured: true,
  },
  {
    id: 'article-2',
    title: 'NBA夏季联赛新星盘点：五大潜力新秀表现亮眼',
    excerpt: '2026年NBA夏季联赛落下帷幕，一批新秀球员展现出了超乎预期的实力和潜力，让我们来盘点表现最出色的五位新星。',
    category: '篮球',
    categorySlug: 'basketball',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20court%20with%20dramatic%20arena%20lighting%2C%20action%20moment%20with%20orange%20basketball%2C%20intense%20sports%20photography%2C%20warm%20arena%20lights%2C%20hardwood%20floor%20reflections&width=800&height=500&seq=article-basketball-1&orientation=landscape',
    date: '2026-08-03',
    readTime: '6分钟',
    featured: true,
  },
  {
    id: 'article-3',
    title: '温网2026回顾：经典对决永载史册',
    excerpt: '2026年温布尔登网球锦标赛精彩回顾，从第一轮到决赛，每一场比赛都充满了悬念与激情。',
    category: '网球',
    categorySlug: 'tennis',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20with%20green%20grass%2C%20player%20in%20white%20tennis%20attire%2C%20elegant%20sports%20photography%2C%20warm%20summer%20afternoon%20lighting%2C%20stadium%20background&width=800&height=500&seq=article-tennis-1&orientation=landscape',
    date: '2026-07-28',
    readTime: '10分钟',
    featured: false,
  },
  {
    id: 'article-4',
    title: '2026全球电竞产业报告：市场规模突破500亿美元',
    excerpt: '最新数据显示，全球电竞产业持续高速增长，2026年市场规模预计将突破500亿美元大关，亚洲市场领跑全球。',
    category: '电竞',
    categorySlug: 'esports',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20colorful%20neon%20lighting%2C%20gaming%20stage%20with%20large%20screens%2C%20professional%20gaming%20setup%2C%20crowded%20venue%20atmosphere%2C%20vibrant%20warm%20and%20cool%20contrast%20lights&width=800&height=500&seq=article-esports-1&orientation=landscape',
    date: '2026-07-25',
    readTime: '7分钟',
    featured: false,
  },
  {
    id: 'article-5',
    title: 'F1 2026赛季技术革新：新一代动力单元深度解析',
    excerpt: 'F1 2026赛季迎来了重大技术规则变革，全新的动力单元设计将如何改变赛道竞争格局？技术专家为您详细解读。',
    category: '赛车',
    categorySlug: 'racing',
    image: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20on%20track%20at%20high%20speed%2C%20motion%20blur%20effect%2C%20dramatic%20racing%20photography%2C%20golden%20hour%20sunset%20lighting%2C%20asphalt%20texture%2C%20professional%20motorsport%20aesthetic&width=800&height=500&seq=article-racing-1&orientation=landscape',
    date: '2026-07-20',
    readTime: '9分钟',
    featured: false,
  },
  {
    id: 'article-6',
    title: 'UFC 310赛后分析：冠军卫冕战的战术博弈',
    excerpt: 'UFC 310主赛上演了精彩的冠军卫冕战，双方选手展现了顶级格斗技巧，让我们从战术角度回顾这场经典对决。',
    category: '格斗',
    categorySlug: 'combat',
    image: 'https://readdy.ai/api/search-image?query=Professional%20MMA%20octagon%20arena%20with%20dramatic%20spotlight%2C%20intense%20fighting%20atmosphere%2C%20warm%20and%20dark%20contrast%20lighting%2C%20professional%20combat%20sports%20photography&width=800&height=500&seq=article-combat-1&orientation=landscape',
    date: '2026-07-15',
    readTime: '7分钟',
    featured: false,
  },
];

export const platformAdvantages = [
  {
    id: 'adv-1',
    title: '全球赛事覆盖',
    description: '覆盖足球、篮球、网球、电竞等30余项主流体育项目，全球200+国家和地区赛事实时更新，让您不错过任何精彩瞬间。',
    icon: 'ri-global-line',
  },
  {
    id: 'adv-2',
    title: '专业数据分析',
    description: '资深体育分析师团队为您提供赛事前瞻、实时数据、赛后复盘，多维度数据帮助您做出更明智的判断。',
    icon: 'ri-line-chart-line',
  },
  {
    id: 'adv-3',
    title: '安全可靠平台',
    description: '采用国际领先的加密技术，多重安全防护体系，保障用户信息安全与资金安全，让您放心享受体育娱乐。',
    icon: 'ri-shield-check-line',
  },
  {
    id: 'adv-4',
    title: '7×24小时客服',
    description: '专业客服团队全天候在线服务，快速响应您的每一个需求，多种沟通渠道随时随地为您排忧解难。',
    icon: 'ri-customer-service-2-line',
  },
];

export const faqItems = [
  {
    id: 'faq-1',
    question: '如何注册开元体育账号？',
    answer: '点击页面右上角的"立即注册"按钮，填写您的手机号码或邮箱地址，设置安全密码，完成验证后即可成功注册。整个过程仅需1分钟，注册即享新人专属福利。',
  },
  {
    id: 'faq-2',
    question: '开元体育平台支持哪些赛事类型？',
    answer: '开元体育平台覆盖足球、篮球、网球、电竞、赛车、格斗、斯诺克、羽毛球等30余项体育项目，提供全球200多个国家和地区的赛事数据与分析，满足不同体育爱好者的多元化需求。',
  },
  {
    id: 'faq-3',
    question: '平台的安全性和合法性如何保障？',
    answer: '开元体育持有国际合法运营牌照，采用银行级SSL加密技术和多重安全验证体系，严格保护用户隐私和资金安全。我们始终遵循合规运营原则，为用户提供安全可靠的体育娱乐环境。',
  },
  {
    id: 'faq-4',
    question: '如何获取最新的赛事优惠和活动信息？',
    answer: '您可以关注开元体育官方公告栏、订阅我们的新闻通讯，或下载开元体育APP开启推送通知。我们会定期推出新用户礼包、赛事竞猜奖励、节日特惠等多种福利活动。',
  },
  {
    id: 'faq-5',
    question: '遇到问题如何联系客服？',
    answer: '您可以通过在线客服（7×24小时）、官方邮箱service@kaiyunsports.com、或拨打客服热线400-xxx-xxxx与我们联系。我们的专业客服团队将第一时间为您解决问题。',
  },
];

export const promotions = [
  {
    id: 'promo-1',
    title: '新人注册礼包',
    description: '首次注册即享专属福利，包括免费投注金和赛事VIP观赛权益',
    icon: 'ri-gift-line',
  },
  {
    id: 'promo-2',
    title: '每日签到奖励',
    description: '每日签到累积积分，兑换丰富体育周边和平台专属权益',
    icon: 'ri-calendar-check-line',
  },
  {
    id: 'promo-3',
    title: '赛事竞猜活动',
    description: '参与热门赛事竞猜，赢取丰厚奖金和限量版纪念品',
    icon: 'ri-trophy-line',
  },
  {
    id: 'promo-4',
    title: '好友推荐计划',
    description: '邀请好友加入开元体育，双方均可获得惊喜推荐奖励',
    icon: 'ri-user-heart-line',
  },
];